import React from 'react';
import { Button } from '@/components/ui/button';
import { Printer, Share2, ThumbsUp, MessageCircle } from 'lucide-react';
import { Separator } from "@/components/ui/separator";

const PostInteractionBar = ({ post, onActionClick, toast }) => {
  if (!post) return null;

  const handleShare = (platform) => {
    const url = window.location.href;
    const text = `Check out this article from WebFiny: ${post.title}`;
    let shareUrl = '';

    if (platform === 'twitter') {
      shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
    } else if (platform === 'linkedin') {
      shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(post.title)}&summary=${encodeURIComponent(post.excerpt)}`;
    } else if (platform === 'facebook') {
      shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    } else if (platform === 'copy') {
      navigator.clipboard.writeText(url).then(() => {
        toast({ title: "Link Copied!", description: "Article URL copied to clipboard.", className: "bg-green-500 text-white" });
      }).catch(err => {
        toast({ title: "Error", description: "Could not copy link.", variant: "destructive" });
      });
      return;
    }
    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer');
    }
    onActionClick(`Share on ${platform}`);
  };

  return (
    <div className="mt-10 md:mt-12 py-6 border-y border-border">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center space-x-2 sm:space-x-3">
          <Button variant="outline" size="sm" onClick={() => onActionClick("Like Post")} aria-label="Like this post">
            <ThumbsUp className="w-4 h-4 mr-1.5" /> Like ({post.likes || 0})
          </Button>
          <Button variant="outline" size="sm" onClick={() => onActionClick("Comment on Post")} aria-label="View comments for this post">
            <MessageCircle className="w-4 h-4 mr-1.5" /> Comments ({post.comments || 0})
          </Button>
        </div>
        <div className="flex items-center space-x-2 sm:space-x-3">
          <Button variant="ghost" size="sm" onClick={() => window.print()} aria-label="Print this article">
            <Printer className="w-4 h-4 mr-1.5 text-muted-foreground" /> <span className="text-muted-foreground">Print</span>
          </Button>
          <Button variant="ghost" size="sm" onClick={() => handleShare('copy')} aria-label="Copy link to this article">
            <Share2 className="w-4 h-4 mr-1.5 text-muted-foreground" /> <span className="text-muted-foreground">Share</span>
          </Button>
          {/* Add more share options if desired, e.g., Twitter, LinkedIn, Facebook buttons */}
        </div>
      </div>
      <Separator className="my-6" />
      <div className="flex flex-wrap gap-2">
        <span className="text-sm font-medium text-foreground mr-2">Tags:</span>
        {post.tags && post.tags.map(tag => (
          <Button 
            key={tag} 
            variant="outline" 
            size="xs" 
            onClick={() => onActionClick(`Filter by Tag: ${tag}`)} 
            className="hover:bg-accent/50"
            aria-label={`Filter posts by tag: ${tag}`}
          >
            #{tag}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default PostInteractionBar;